/* istanbul ignore file */
import _merge from 'lodash/merge';
import { STRINGS as CONSTANTS } from 'config/constants';
import { developmentConfig } from 'config/develop';
import { testConfig } from 'config/test';
import { dteConfig } from 'config/dte';
import { productionConfig } from 'config/production';

const environment = process.env.REACT_APP_ENVIRONMENT ? process.env.REACT_APP_ENVIRONMENT : 'development';

const getEnvironment = () => {
  switch (environment) {
    case 'production':
      return productionConfig;
    case 'test':
      return testConfig;
    case 'dte':
      return dteConfig;
    case 'development':
      return developmentConfig;
    default:
      return {};
  }
};

export const STRINGS = _merge({}, CONSTANTS, getEnvironment());
